import { render, staticRenderFns } from "./DoorsManager.vue?vue&type=template&id=5c71fd14"
import script from "./DoorsManager.vue?vue&type=script&lang=js"
export * from "./DoorsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports